import { render, staticRenderFns } from "./PaymentInfoBox.vue?vue&type=template&id=5a2f551d&"
import script from "./PaymentInfoBox.vue?vue&type=script&lang=js&"
export * from "./PaymentInfoBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports